export const debounce = function(fn, delay) {
  let timeoutID = null

  return function() {
    clearTimeout(timeoutID)
    const args = arguments
    const that = this

    timeoutID = setTimeout(function() {
      fn.apply(that, args)
    }, delay)
  }
}

export const empty = (v) => v === undefined || v === null || (v + '').trim() === ''

export const screenPosition = (e) => {
  const note = $(e).get(0)
  return note.getBoundingClientRect()
}

export const template = (data, tpl) => {
  const html = $(tpl)
    .html()
    .trim()
  return html.replace(/\{\{([a-z_]+)\}\}/gi, (_, m) => data[m] || '')
}

// export const throttle = (type, name, obj) =>{
//   obj = obj in window
//   let running = false

//   func = ()=>{
//     if (running){
//       return
//     }
//     running = true
//     requestAnimationFrame(()=>{

//       obj.dispatchEvent new CustomEvent(name)
//       running = false
//       return
//     }
//     return
//     )
//   }

//   obj.addEventListener type, func
//   return
// }



// WEBPACK FOOTER //
// app/javascript/sg/js/utils.js